import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DirectiveModule } from '@fcom/common/directives/directive.module';

import { ProgressCircleComponent } from './progress-circle.component';

@NgModule({
  declarations: [ProgressCircleComponent],
  imports: [CommonModule, DirectiveModule],
  exports: [ProgressCircleComponent],
})
export class ProgressCircleModule {}
